package ui.new_ui.components.card_item

import emotion.react.css
import helpers.PropsWithCss
import react.FC
import react.Props
import react.PropsWithChildren
import react.PropsWithStyle
import react.dom.html.ReactHTML
import web.cssom.*

external interface CardItemProps: PropsWithChildren, PropsWithCss

val CardItem = FC<CardItemProps> {props ->
    ReactHTML.div{
        css {
            minHeight = CardStyles.minHeight
            borderRadius = CardStyles.borderRadius
            display = Display.flex
            position = Position.relative
            flexDirection = FlexDirection.column

            boxShadow = BoxShadow(
                offsetX = 0.px,
                offsetY = 0.px,
                blurRadius = CardStyles.Shadow.shadowBlurRadius,
                spreadRadius = CardStyles.Shadow.shadowSpreadRadius,
                color = CardStyles.Shadow.shadowColor()
            )
            margin = CardStyles.margin
            padding = CardStyles.padding
            backgroundColor = CardStyles.backgroundColor()
            props.css(this)
        }

        +props.children
    }
}